<script>
  import { Link } from "svelte-navigator";
  export let links;
  let menuOpen = false;
</script>

<nav>
  <i class="fas fa-bars fa-2x" on:click={() => menuOpen = !menuOpen} />
  <div id="link-container" class={menuOpen ? "open" : ""}>
    {#each links as link, idx}
      <Link on:click={() => menuOpen = false} class="nav-link" to={idx === 0 ? "/" : link.toLowerCase()}
        >{link}</Link
      >
    {/each}
  </div>
</nav>

<style>
  nav {
    padding-top: .5rem;
    margin: 0 auto;
    max-width: 38rem;
    width: calc(100% - 1rem);
  }
  i {
    display: block;
    height: 2rem;
    width: 2rem;
    margin: 0 auto;
  }
  div#link-container {
    display: none;
    z-index: 999;
  }
  div#link-container.open {
    display: flex;
    flex-direction: column;
    background-color: #CDCBCE;
    position: fixed;
    left: 0;
    width: 100%;
    border-radius: 2px;
    box-shadow: 0 8px 6px -6px  #4A422F;
  }

  @media only screen and (min-width: 640px) {
    i {
      display: none;
    }
    div#link-container {
      display: flex;
      justify-content: space-evenly;
    }
  }
</style>
